import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Svg } from '../Icon/Base.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["color"];
var IconFavoriteSelected = /*#__PURE__*/React.memo(function (_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? "currentColor" : _ref$color,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/jsx(Svg, _objectSpread(_objectSpread({
    viewBox: "0 0 25 25"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.73 1.2l3.345 6.629 6.44.638a.805.805 0 01.5 1.374l-5.3 5.253 1.965 7.138a.813.813 0 01-1.15.935L12 19.934l-6.52 3.229a.813.813 0 01-1.15-.935l1.964-7.138L.99 9.837a.805.805 0 01.5-1.374l6.44-.638L11.271 1.2a.819.819 0 011.458 0z",
      fill: color,
      stroke: color,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  }));
});
IconFavoriteSelected.displayName = "IconFavoriteSelected";

export { IconFavoriteSelected };
